import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { EgBrandService } from '@expertgroup/shell';

/**
 * Naslov taba: „Stranica · ProTax", gde je osnova `documentTitle` maske, inače ime proizvoda.
 *
 * Ljuska ne preuzima `TitleStrategy` — naslov postavlja `EgBrandService.title()`, a posle prvog poziva ga i održava
 * (naslov se osveži kad se maska promeni, bez nove navigacije). Zato ovde nema `Title.setTitle`.
 *
 * Stranica je `title` rute ako ga ima, inače `data.breadcrumb` najdublje rute: isti tekst koji gornja traka već piše,
 * pa se tab i putanja ne razilaze. Rute bez ijednog od ta dva (početna, zabranjen pristup, 404) dobijaju samo osnovu.
 * Tekst stranice je srpski u oba jezika, kao i putanja u traci — rute nose literal, ne ključ kopije.
 */
@Injectable({ providedIn: 'root' })
export class ProtaxTitleStrategy extends TitleStrategy {
    private readonly brand = inject(EgBrandService);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        this.brand.title(this.buildTitle(snapshot) ?? breadcrumbOf(snapshot));
    }
}

/** `data.breadcrumb` najdublje aktivne rute; `undefined` kad je nema ili nije tekst. */
function breadcrumbOf(snapshot: RouterStateSnapshot): string | undefined {
    let route = snapshot.root;
    while (route.firstChild) {
        route = route.firstChild;
    }
    const breadcrumb: unknown = route.data['breadcrumb'];
    return typeof breadcrumb === 'string' && breadcrumb ? breadcrumb : undefined;
}
